import { FieldMeta, SettingsMap } from '../../../types/webchatTabsTypes';

export const normalizeResponse = (raw: unknown): SettingsMap => {
  if (Array.isArray(raw)) {
    const mapped: SettingsMap = {};
    for (const item of raw) {
      if (!item || typeof item !== 'object') continue;
      const rec = item as Record<string, unknown>;
      const key = typeof rec.key === 'string' ? rec.key : '';
      if (!key) continue;
      mapped[key] = {
        value: (rec.value as string | number) ?? '',
        default: (rec.default as string | number) ?? (rec.defaultValue as string | number) ?? '',
      };
    }
    return mapped;
  }
  if (raw && typeof raw === 'object') {
    const container = raw as Record<string, unknown>;
    if (Array.isArray(container.settings)) return normalizeResponse(container.settings);
    if (Array.isArray(container.data)) return normalizeResponse(container.data);
  }
  return {};
};

export const matchesSearch = (field: FieldMeta, term: string) => {
  if (!term) return false;
  const t = term.toLowerCase();
  return field.label.toLowerCase().includes(t) || field.description.toLowerCase().includes(t) || field.key.toLowerCase().includes(t);
};
